import localforage from "localforage";

export const atomPersistor = {
  ...localforage,
  setItem: async <Value>(key: string, value: Value) => {
    localforage.setItem<Value>(key, value);
  },
};
